import React from 'react'
import { FormattedMessage } from 'react-intl'
import capitalizeString from 'utils/capitalize'
import { RedListCategoryStatus, TableNotQualifyIconWrapper } from './style'
import Tooltip from 'components/Tooltip'
import RejectIcon from 'assets/icons/reject-icon'
import { reassessmentTriggerReasons } from 'constants/reassessmentTriggerReasons'
import { createColumn } from '../../../../utils/tableColumnHelpers'
import {
  isQualifyingTriggerReason,
  normalizeTriggerReasonIds
} from 'utils/speciesCriteriaMet/normalizeTriggerReasonId'

export const renderRedListCategoryStatus = (status) => {
  if (status === '-') {
    return (
      <div>
        -
      </div>
    )
  }
  const numberStatus = {
    1: 'CO',
    2: 'CR',
    3: 'EN',
    4: 'VU',
    5: 'NT',
    6: 'LC',
    7: 'DD',
    8: 'NE'
  }

  const color = {
    1: '#202020',
    2: 'rgba(216, 30, 5, 0.5)',
    3: 'rgba(252, 127, 63, 0.6)',
    4: 'rgba(249, 232, 20, 0.6)',
    5: 'rgba(204, 226, 38, 0.6)',
    6: 'rgba(96, 198, 89, 0.6)',
    7: '#D1D1C6',
    8: 'rgb(255, 255, 255)'
  }

  return (
    <RedListCategoryStatus color={color[status]}>
      <FormattedMessage id={numberStatus[status]} />
    </RedListCategoryStatus>
  )
}


const tooltipXOffset = 0
const tooltipYOffset = -16

const formattedRejectIconTooltipHint = (item) => {
  return normalizeTriggerReasonIds(item).map((element) => {
    return reassessmentTriggerReasons.find((elementId) => elementId.id === element)?.name
  }).filter(Boolean)
}

const notQualifyIcon = (hint) => {
  return (
    <Tooltip
      style={{ zIndex: 1000 }}
      placement='top'
      trigger={['hover']}
      align={{ offset: [tooltipXOffset, tooltipYOffset] }}
      overlay={{ label: 'nonQualifying', infoTooltip: formattedRejectIconTooltipHint(hint).join(', ') }}
    >
      <TableNotQualifyIconWrapper>
        <RejectIcon />
      </TableNotQualifyIconWrapper>
    </Tooltip>

  )
}

const parsePopulationValue = (population) => {
  const numericValue = Number(population?.split('%').join(''))
  const isInvalidNumber = !Number.isFinite(numericValue) || Number.isNaN(numericValue)

  if (isInvalidNumber) {
    return '-'
  }

  return population
}

export const mapEcoCalculatorDataFromApi = (data = []) => {
  if (!Array.isArray(data)) {
    return []
  }

  return data.map((item) => {
    const kbaCriterias = Array.isArray(item?.kbaCriterias) ? item.kbaCriterias : []

    return {
      ecosystemName: item?.name ? item.name : '-',
      iucnStatus: item?.EcoSystemRedListId ? item.EcoSystemRedListId : '-',
      population: item?.globalPopulation,
      kbaCriteria: kbaCriterias.length ? kbaCriterias.join(', ') : '-',
      triggerReasonId: normalizeTriggerReasonIds(item?.triggerReasonId)
    }
  })
}

export const makeCalculationRowEco = (calculationDataEco, site) => {
  if (!Array.isArray(calculationDataEco)) {
    return []
  }

  return calculationDataEco.map((item) => {
    const qualifies = site.reassessmentFlag
      ? isQualifyingTriggerReason(item.triggerReasonId)
      : true
    const population = qualifies ? parsePopulationValue(item.population) : '-'
    const kbaCriteria = qualifies
      ? capitalizeString(item.kbaCriteria)
      : notQualifyIcon(normalizeTriggerReasonIds(item.triggerReasonId))

    return {
      ecosystemName: `${capitalizeString(item.ecosystemName)}`,
      iucnStatus: renderRedListCategoryStatus(item.iucnStatus),
      population,
      kbaCriteria
    }
  })
}

export const makeCalculationsColumnsEco = () => {
  return [
    createColumn({
      id: 'ecosystemName',
      headerId: 'ecosystemName',
      accessorKey: 'ecosystemName',
      style: {
        width: '65%'
      }
    }),
    createColumn({
      id: 'iucnStatus',
      headerId: 'iucnStatus',
      accessorKey: 'iucnStatus'
    }),
    createColumn({
      id: 'population',
      headerId: 'population',
      accessorKey: 'population'
    }),
    createColumn({
      id: 'kbaCriteria',
      headerId: 'kbaCriteria',
      accessorKey: 'kbaCriteria',
      style: {
        width: '10%'
      }
    })
  ]
}
